import { Button } from "react-bootstrap";
import { Spinner } from "components";

type PopupTopBarProps = {
    counter: number;
    saving: boolean;
    onSave: () => void;
}

export function PopupTopBar(props: PopupTopBarProps) {
    return (
        <div className="gap-1 d-flex">           
            <Button variant="primary" disabled={props.saving || props.counter === 0} className="btn-icon me-0 custom-btn-icon" onClick={props.onSave}>
                {props.saving ? <><Spinner className="spinner-border-sm me-1" tag="span" color="white" /></> : <></>}
                {props.saving ? <>Loading...</> : <>Add Selected</>}
            </Button>
        </div>
    );
}